import { render, staticRenderFns } from "./ApprovalCustomerChanges.vue?vue&type=template&id=4025ca5b&"
import script from "./ApprovalCustomerChanges.vue?vue&type=script&lang=js&"
export * from "./ApprovalCustomerChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports